import React, { useState } from "react";
import { useTemplateStore } from "@/zustand/templateStore";

const CardCvc = ({
  dataTestId,
  placeholder,
  error,
  name,
  width,
  value,
  margin,
  icon,
  min,
  max,
  comment,
  setValue,
  submitCount,
  register,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const { isMobile } = useTemplateStore();
  const isEnhancedContrast = window.enhancedContrast;

  return (
    <div
      className="input-container"
      style={{
        width: width == "full" ? "100%" : `calc(${width == "half" ? 50 : width}% - 6px)`,
        marginInlineEnd: margin ? "12px" : "0px",
        backgroundColor: "transparent",
      }}
    >
      <div
        className={`input input--text ${error && "input--error"} ${isEnhancedContrast && "enhancedContrast"} ${isEnhancedContrast && error && "enhancedContrast__error"}`}
      >
        <input
          data-testid={dataTestId}
          maxLength={max}
          minLength={min}
          type="tel"
          autoComplete="cc-csc"
          className="styledInput"
          name={name}
          value={value}
          {...register(name)}
          onChange={(e) => {
            const numericValue = e.target.value.replace(/[^0-9]/g, "");
            setValue(name, numericValue, {
              shouldValidate: true,
              shouldTouch: true,
            });
          }}
        />
        <label
          className={`styledLabel cvv ${value?.length > 0 ? "styledLabel--active" : ""} ${isEnhancedContrast && "styledLabel__enhancedContrast"}`}
        >
          {placeholder}
        </label>

        {icon && (
          <div
            className="input__helper"
            onClick={() => {
              if (isMobile) {
                setIsVisible(!isVisible);
              }
            }}
          >
            <div
              className="input__img--alt"
              style={{
                backgroundImage: `url(${icon}`,
              }}
            />

            {comment && (
              <span className="input__comment" visible={isVisible.toString()}>
                {comment}
              </span>
            )}
          </div>
        )}
      </div>
      {error && <span className="formError">{error}</span>}
    </div>
  );
};

export default CardCvc;
